import { Fragment } from "react";
import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import ImageOrVideo from "./ImageOrVideo";
import formatDate from "../utils/formatDate";
import activeObjSearch from "../utils/activeObjSearch";
import OverviewPageInfo from "./Story/OverviewPageInfo";
import NavigationBlock from "./Story/NavigationBlock";
import StoryList from "./Story/StoryList";

const StoryPage = ({ page }) => {
  const lang = page.language();
  const pageClass = page.objClass();
  const displayOnThisPage = page.get("displayOnThisPage");
  const [mainOverviewPage] = displayOnThisPage;
  const tags = page.get("tags").length > 0 ? page.get("tags") : ["university"];

  const baseQuery = () => {
    let q = activeObjSearch().and("_objClass", "equals", pageClass);
    if (displayOnThisPage?.length) {
      q = q.and("displayOnThisPage", "refersTo", displayOnThisPage);
    }
    return q;
  };

  const newest = baseQuery().order("publishFromDate", "desc").take(3);

  const recommened = baseQuery()
    .andNot("id", "equals", page.id())
    .and("tags", "equals", tags)
    .take(3);

  const hasMedia = page.get("image");
  const mediaClass = hasMedia ? "col-12 col-lg-5" : "";
  const contentClass = hasMedia ? "col-12 col-lg-7" : "col-12";

  return (
    <Fragment>
      <div className="page-header-widget bg-blue">
        <div className="container">
          <div className="row">
            {hasMedia && (
              <div className={`${mediaClass} position-relative`}>
                <div className="page-header-widget__media">
                  <ImageOrVideo
                    widget={page}
                    className="page-header-widget__image img-fluid"
                  />
                </div>
              </div>
            )}
            <div className={contentClass}>
              {page.get("shortTitle") ? (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="shortTitle"
                />
              ) : (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="title"
                />
              )}
              <Scrivito.ContentTag
                className="page-header-widget__description"
                content={page}
                attribute="description"
              />
              <div className="mb-2">
                <i className="las la-user me-1" />
                {page.get("author")}
                <span className="mx-2">|</span>
                <span>
                  {formatDate(page.get("publishFromDate"), "DD.MM.YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-0">
        <nav
          aria-label="breadcrumb row"
          className="breadcrumb-wrapper --page-mode"
        />
      </div>

      <article className="container s-py-3" role="main">
        <div className="row">
          <div className="col-sm-8">
            {page.get("shortTitle") ? (
              <Scrivito.ContentTag
                tag="h3"
                className="page-header-widget__headline"
                content={page}
                attribute="shortTitle"
              />
            ) : (
              <Scrivito.ContentTag
                tag="h3"
                className="page-header-widget__headline"
                content={page}
                attribute="title"
              />
            )}
            <Scrivito.ContentTag tag="div" content={page} attribute="body" />
            <NavigationBlock
              mainOverviewPage={mainOverviewPage}
              pageClass={pageClass}
              publishFromDate={page.get("publishFromDate")}
            />
          </div>
          <div className="col-sm-4">
            {page.get("displayOnThisPage").map((item) => (
              <OverviewPageInfo
                page={item}
                language={lang}
                key={item.id()}
                objClass={pageClass}
              />
            ))}

            <StoryList
              list={recommened}
              title={I18n.t("BlogPost recommended articles")}
            />
            <StoryList
              list={newest}
              title={I18n.t("BlogPost current articles")}
            />
          </div>
        </div>
      </article>
    </Fragment>
  );
};
export default Scrivito.connect(StoryPage);
